/** #9 — Founder's Note block for About page. Builds parasocial trust. */
export default function FounderNote() {
  return (
    <section className="py-16 sm:py-24 bg-[#0A0A0A] border-y border-white/5" data-testid="founder-note">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37] mb-4 font-sans">A note from the founder</p>
        <p
          className="text-2xl sm:text-3xl text-white font-light leading-relaxed mb-8"
          style={{ fontFamily: 'Cormorant Garamond, serif' }}
        >
          "I started JS Fragrance because luxury should be felt — not just paid for.
          Every drop is composed for presence, depth, and the kind of memory you wear all day.
          We're a small Filipino studio, but we obsess over every batch like it's our last."
        </p>
        {/* Handwritten-style signature */}
        <svg
          viewBox="0 0 220 60"
          className="mx-auto h-12 w-auto opacity-90"
          aria-label="Founder signature"
        >
          <path
            d="M10 35 C 25 18, 40 50, 55 32 S 80 15, 95 38 S 130 12, 145 35 S 175 50, 195 28"
            stroke="#D4AF37"
            strokeWidth="1.5"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <text x="115" y="55" textAnchor="middle" fontFamily="Cormorant Garamond, serif"
            fontStyle="italic" fontSize="13" fill="#D4AF37">— J.S.</text>
        </svg>
        <p className="text-white/30 text-[11px] uppercase tracking-[0.2em] font-sans mt-4">
          Founder · JS Fragrance · Manila
        </p>
      </div>
    </section>
  );
}
